<template>
  <div id="login">
    <!-- <PasswordReset v-if="showPasswordReset" @close="togglePasswordReset()"></PasswordReset> -->
    <section class="section is-medium">
      <div class="columns">
        <div class="column col1">
          <!-- <h1 class="title has-text-white">FindUPix</h1> -->
          <p class="subtitle has-text-white">Bienvenido</p>
        </div>
        <div :class="{ 'signup-form': !showLoginForm }" class="column col2">
          <form v-if="showLoginForm" @submit.prevent>
            <div>
              <img src="../assets/findupix-logo-svg.svg" class="brand-login" alt="FindUPix" />

              <label for="email1">Email</label>
              <input
                v-model.trim="loginForm.email"
                type="text"
                placeholder=""
                id="email1"
              />
            </div>
            <div>
              <label for="password1">Contraseña</label>
              <input
                v-model.trim="loginForm.password"
                type="password"
                placeholder=""
                id="password1"
              />
            </div>
            <button @click="login()" class="button">Acceder</button>
          </form>

          <div class="columns sponsors is-multiline">
            <div class="column is-one-quarter">
              <img src="../assets/img/logo-1.jpg" class="sponsor" />
            </div>
            <div class="column is-half">
              <img src="../assets/img/logo-2.jpg" class="sponsor" />
            </div>
            <div class="column is-one-quarter">
              <img src="../assets/img/logo-3.jpg" class="sponsor" />
            </div>
            <div class="column fondo">
              Proyecto cofinanciado por el <span>Fondo Europeo de desarrollo regional</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        name: "",
        title: "",
        email: "",
        password: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
    };
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login() {
      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });
    },
  },
};
</script>
<style scoped>
.brand-login {
  height: 100px;
}
</style>